// extracted by mini-css-extract-plugin
var _1 = "UsersSettings_headerButton__kcHkw";
var _2 = "UsersSettings_headerButtonOffset__lE8+1";
export { _1 as "headerButton", _2 as "headerButtonOffset" }
